import GROUP_SESSION_URL_PREFIX from "./constants/group-session-url-prefix";

export default function getGroupSessionUrl({
  zoom_meeting,
  twilio_url_code,
}: GroupSessionMetaData) {
  return (
    zoom_meeting?.join_link || `${GROUP_SESSION_URL_PREFIX}${twilio_url_code}`
  );
}
